import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  FormControl,
  Validator,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { Input, Component, forwardRef, OnInit, ViewChild } from '@angular/core';
import { Formatting } from '../../utils/formatting.utils';

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DecimalNumberComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DecimalNumberComponent),
            multi: true,
        },
    ],
    selector: 'app-decimal-number',
    templateUrl: './decimal-number.component.html',
    styleUrls: ['./decimal-number.component.css'],
    styles: [
        `
      .mat-mdc-input-element {
        vertical-align: initial;
      }
    `,
    ],
    standalone: false
})
export class DecimalNumberComponent
  implements OnInit, ControlValueAccessor, Validator
{
  @ViewChild('clra', { static: true }) control: FormControl;
  @Input() currency: string;
  @Input() placeholder: string;
  @Input() pattern: string;
  @Input() requiredError: any;
  @Input() validationError: any;
  @Input() decimal: number;
  @Input() controlIdentifier: string;
  @Input() maxSize: number;
  @Input() disabled = false;
  @Input() autocomplete = 'on';

  private formatting = Formatting;

  get mask() {
    let mask = '0' + '9'.repeat(this.maxSize - this.decimal - 1);

    if (this.decimal > 0) {
      mask += ',' + '0'.repeat(this.decimal);
    }

    return mask;
  }

  maxDigitalNr: number;
  onChange: any;
  value: string;

  ngOnInit(): void {
    this.maxDigitalNr = Object.seal(this.maxSize);
  }

  writeValue(value: any): void {
    this.value = value ?? '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(_fn: any): void {
    return;
  }

  onRequestedAmountFocusOut() {
    if (!this.value) {
      return;
    }

    switch (this.decimal) {
      case 0:
        break;
      case 1:
        this.value = this.formatting.toDecimalNumberWithOneDecimal(
          this.value,
          false,
          '0',
        );
        this.onChange(this.value);
        break;
      case 2:
        this.value = this.formatting.toSimpleDecimalNumber(this.value, false);
        this.onChange(this.value);
        break;
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === undefined || value === '') return null;

    const regex = new RegExp(this.pattern);

    return regex.test(value) ? null : { invalidNumber: true };
  }

  onInput(event: any): void {
    this.value = event.target.value;
    this.onChange(this.value);
  }
}
